var map = {
	"./add.png": 834255,
	"./aiChatHome.png": 322493,
	"./chat-bg.png": 299140,
	"./chat-loading.png": 444441,
	"./check.png": 18478,
	"./claw-tip.png": 330013,
	"./close.png": 918634,
	"./cloud_logo.png": 532047,
	"./company_overview.png": 686921,
	"./company_overview_highlight.png": 832832,
	"./csv.png": 92566,
	"./data-source-announcement.png": 173462,
	"./data-source-basic.png": 54273,
	"./data-source-financial.png": 646302,
	"./data-source-fund.png": 16990,
	"./data-source-macro.png": 867271,
	"./data-source-market.png": 940075,
	"./data-source-news.png": 393326,
	"./data-source-research.png": 488188,
	"./data_cube.png": 679282,
	"./default_avatar.png": 448813,
	"./doc.png": 225868,
	"./event_review.png": 414935,
	"./event_review_highlight.png": 365978,
	"./file.png": 286274,
	"./generate_company_brief.png": 383868,
	"./generate_company_report_en.png": 428812,
	"./generate_company_report_zh.png": 37119,
	"./generate_industry_depth_en.png": 688754,
	"./generate_industry_depth_zh.png": 840597,
	"./generate_macro_strategy_en.png": 830426,
	"./generate_macro_strategy_zh.png": 663309,
	"./global-search.png": 265932,
	"./greet.png": 415309,
	"./hot-domestic-report.png": 647007,
	"./hot-foreign-report.png": 438601,
	"./hot-summary.png": 333804,
	"./html-preview/zoom-in.png": 148498,
	"./html-preview/zoom-in.svg": 747628,
	"./html-preview/zoom-out.png": 447203,
	"./html-preview/zoom-out.svg": 598067,
	"./html.png": 32171,
	"./icon-research-analyzing.png": 313883,
	"./icon-research-customize.png": 403919,
	"./icon-research-industry.png": 46618,
	"./icon-research-stock.png": 795768,
	"./img.png": 199983,
	"./indicators_load_bg.png": 725541,
	"./industry_overview.png": 404090,
	"./industry_overview_highlight.png": 874151,
	"./industry_popular_science.png": 45567,
	"./jinbao.png": 167547,
	"./link.png": 668168,
	"./markdown.png": 621367,
	"./mcp-auth-success.png": 251165,
	"./mcp-connector-icon-eastmoney.png": 909986,
	"./mcp-connector-icon-ifind.png": 400031,
	"./mcp-connector-icon-ima.png": 761420,
	"./mcp-connector-icon-investoday.png": 992715,
	"./mcp-connector-icon-qieman.png": 265950,
	"./mcp-connector-icon-tdx.png": 891383,
	"./mcp-connector-icon-tushare.png": 146593,
	"./mcp-connector-icon-wind.png": 870685,
	"./mcp-service-default-icon.png": 904772,
	"./mcp_bg.png": 376030,
	"./menu.png": 200181,
	"./new-tip.png": 824080,
	"./no_check.png": 779440,
	"./note.png": 493532,
	"./other_file.png": 951827,
	"./pdf.png": 151180,
	"./performance_review.png": 881097,
	"./performance_review_highlight.png": 246272,
	"./ppt.png": 935506,
	"./question_tip.png": 115294,
	"./recommend.svg": 659032,
	"./report_logo.png": 285826,
	"./research-action-menu/cloud-import.svg": 293020,
	"./research-action-menu/folder.svg": 270123,
	"./research-action-menu/local-import.svg": 9294,
	"./research-file-type/excel.svg": 276633,
	"./research-file-type/file.svg": 553202,
	"./research-file-type/folder-custom.svg": 683000,
	"./research-file-type/folder-default.svg": 485532,
	"./research-file-type/folder-industry.svg": 721923,
	"./research-file-type/folder-stock.svg": 467813,
	"./research-file-type/html.svg": 890655,
	"./research-file-type/image.svg": 198679,
	"./research-file-type/md.svg": 743715,
	"./research-file-type/pdf.svg": 260906,
	"./research-file-type/ppt.svg": 675132,
	"./research-file-type/word.svg": 983504,
	"./research-session.png": 647404,
	"./research.png": 668175,
	"./research_review.png": 703444,
	"./research_review_highlight.png": 374837,
	"./roadshow.png": 66425,
	"./sandbox-sleep.png": 797273,
	"./session-compress-left.svg": 359215,
	"./session-compress-right.svg": 474890,
	"./share-bg.png": 366555,
	"./share-header-bg.png": 483509,
	"./sheet_paper_bg.png": 9436,
	"./sheet_paper_title_left.svg": 36061,
	"./sheet_paper_title_right.svg": 762592,
	"./skill-shortcuts/icon-bianji.png": 864971,
	"./skill-shortcuts/icon-create-skill.png": 518466,
	"./skill-shortcuts/icon-diaoyan.png": 326307,
	"./skill-shortcuts/icon-gongzhonghao.png": 532957,
	"./skill-shortcuts/icon-hangye.png": 459620,
	"./skill-shortcuts/icon-quanshang.png": 892566,
	"./skill-shortcuts/icon-shengtu.png": 282390,
	"./skill-shortcuts/icon-tonghuashun.png": 417884,
	"./skill-shortcuts/icon-twitter.png": 425321,
	"./skill-shortcuts/icon-youdao.png": 891965,
	"./summary.png": 991178,
	"./summary_file.png": 508245,
	"./summary_logo.png": 148162,
	"./transfer.png": 74385,
	"./translation.png": 489719,
	"./txt.png": 894542,
	"./viewpoint_comparison.png": 168405,
	"./viewpoint_comparison_highlight.png": 17348,
	"./web_logo.png": 214820,
	"./wechat-share-bg.png": 202370,
	"./weichat_logo.png": 971007,
	"./xlsx.png": 989917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228670;